import * as React from "react";
import { useDashboard } from "./DashboardContext.js";

export interface PlanUsage {
  plan: string;
  label: string;
  aiActionsUsed: number;
  aiActionsLimit: number;
  homesUsed: number;
  homesLimit: number;
  photosEnabled: boolean;
  maxPhotos: number;
  photosUsed: number;
  maxPhotosPerItem: number;
  storeOriginal: boolean;
  maxPhotoBytes: number;
  adsEnabled: boolean;
  sharingEnabled: boolean;
}

const PlanContext = React.createContext<{ usage: PlanUsage | null; refresh: () => void }>({ usage: null, refresh: () => {} });

export const usePlan = () => React.useContext(PlanContext);

export function PlanProvider({ children }: { children: React.ReactNode }) {
  const { data, refresh } = useDashboard();

  return <PlanContext.Provider value={{ usage: data?.plan ?? null, refresh }}>{children}</PlanContext.Provider>;
}
